module.exports = __webpack_public_path__ + "img/findmykit-lifestyle-5.0500ccc8.png";